import { Box, Checkbox, Tooltip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import React from "react";
import { UserDepartmentPositionResponse } from "@/types/user";

export const createUserColumns = (
  filteredUsers: UserDepartmentPositionResponse[],
  onChangeHeadUsers: (ids: number[], checked: boolean) => void
): GridColDef[] => [
  {
    field: "userName",
    headerAlign: "center",
    headerName: "이름(Account ID)",
    minWidth: 280,
    sortable: false,
    renderCell: (params: GridRenderCellParams<UserDepartmentPositionResponse>): React.ReactNode => (
      <Tooltip title={`${params.row.userName} (${params.row.userAccountId})`} arrow>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {params.row.userName}
          <span style={{ color: "#666" }}>({params.row.userAccountId})</span>
        </Box>
      </Tooltip>
    ),
  },
  { field: "userEmail", headerName: "이메일", flex: 1, sortable: false },
  {
    field: "isHead",
    headerName: "조직장",
    headerAlign: "center",
    align: "center",
    width: 120,
    sortable: false,
    renderHeader: () => (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Checkbox
          size='small'
          indeterminate={filteredUsers.some((u) => u.isHead) && filteredUsers.some((u) => !u.isHead)}
          checked={filteredUsers.length > 0 && filteredUsers.every((u) => u.isHead)}
          onChange={(_, checked) => {
            onChangeHeadUsers(
              filteredUsers.map((u) => u.id),
              checked
            );
          }}
        />
        <span style={{ marginLeft: 4 }}>조직장</span>
      </Box>
    ),
    renderCell: (params: GridRenderCellParams<UserDepartmentPositionResponse>): React.ReactNode => (
      <Checkbox
        checked={!!params.value}
        onChange={() => {
          onChangeHeadUsers([params.row.id], !params.value);
        }}
        size='small'
      />
    ),
  },
];
